import { staticAssetsPath } from '../../configs/constants'
import {
  SET_ALI_OPEN_SIDEBAR,
  SET_ALI_DRAWER_WIDTH,
  SET_FULL_SCREEN,
  SET_SHOW_DATATOPIC_MODAL,
  SET_SMART_FLOW,
  SET_SELECTED_PERSONA,
  SET_CHAT_MODELS,
  SET_SELECTED_CHAT_MODEL,
  SET_MCP_SERVERS
} from '../actions/chatbotActions'

const aliIcon = `${staticAssetsPath}/images/logo/ALI_Chatbot-vb.png`

const initialState = {
  isFullScreen: false,
  openSidebar: false,
  aliDrawerWidth: '',
  showDataTopicModal: false,
  showSmartFlow: false,
  selectedAgent: {
    id: 'd2d12f41-449c-4245-93f1-4242c9e4eb04',
    name: 'Centrali',
    avatarUrl: aliIcon
  },
  chatModels: null,
  selectedChatModel: null
}

export default function chatbotReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ALI_DRAWER_WIDTH: {
      return {
        ...state,
        aliDrawerWidth: action.payload
      }
    }
    case SET_ALI_OPEN_SIDEBAR:
      return {
        ...state,
        openSidebar: action.payload.openSidebar
      }
    case SET_FULL_SCREEN:
      return {
        ...state,
        isFullScreen: action.payload
      }
    case SET_SHOW_DATATOPIC_MODAL:
      return {
        ...state,
        showDataTopicModal: action.payload
      }
    case SET_SMART_FLOW:
      return {
        ...state,
        showSmartFlow: action.payload
      }
    case SET_SELECTED_PERSONA:
      return {
        ...state,
        selectedAgent: action.payload
      }
    case SET_CHAT_MODELS:
      return {
        ...state,
        chatModels: action.payload
      }
    case SET_MCP_SERVERS:
      return {
        ...state,
        mcpServers: action.payload
      }
    case SET_SELECTED_CHAT_MODEL:
      return {
        ...state,
        selectedChatModel: action.payload
      }
    default:
      return state
  }
}
